import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'convertEmpty'
})
export class ConvertEmptyPipe implements PipeTransform {

    transform(value: any, args?: any): any {
      if (value) {
          return value;
      }
        return '----';
    }

}
